import { makeStyles } from '@material-ui/core/styles';

const productCardStyles = makeStyles(({ breakpoints }) => ({
  card: {
    border: '2px solid',
    borderColor: '#f3f4f5',
    borderRadius: '8px',
    padding: '16px',
    marginTop: '16px',
    marginRight: '16px',
    alignItems: 'center',
    background: '#fff',
    [breakpoints.down('xs')]: {
      marginRight: 0,
    },
    '&:hover': {
      borderColor: '#0086ff',
    },
    '& img': {
      maxHeight: '90px',
      borderRadius: '8px',
      marginRight: '16px',
      [breakpoints.up('sm')]: {
        maxHeight: '120px',
      },
    },
  },
  productTitle: {
    fontSize: '1.1rem',
    marginBottom: '1rem',
  },
}));

export { productCardStyles };
